import React, { useEffect, useState } from "react";
import styled from "styled-components";
import axios from "axios";

import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";

import CircularProgress from "@mui/material/CircularProgress";
import DeleteIcon from "@material-ui/icons/Delete";
import EmailIcon  from "@material-ui/icons/Mail";
import TextField from "@mui/material/TextField";

const columns = [
  { id: "email", label: "User Email" }, //,minWidth: 170
  { id: "delete", label: "Delete User", align: "center"}, //, minWidth: 100
  { id: "invitation", label: "Resend Invite", align: "center"}, //
];

function AddDeleteUserCompany(props) {
  const [user] = useState(JSON.parse(localStorage.getItem("user")));
  const [recordProps, setRecordProps] = useState(props.data);
  const [courseStatusSelected] = useState("");
  const [userInvite, setUserInvite] = useState("");
  const [userInviteFullName, setUserInviteFullName] = useState("");
  const [inviteTeamId, setInviteTeamId] = useState(props.teamIdProp);
  const [teamName, setTeamName] = useState();

  const [inviteTeamButtonVisible, setInviteTeamButtonVisible] = useState(false);
  const [inviteMessage, setInviteMessage] = useState("");
  const [resendInviteMessage, setResendInviteMessage] = useState("");

  let filtered;
  // ========================================================

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  const [mainRecordProps, setMainRecordProps] = useState(null);
  const [searchedRecords, setSearchedRecords] = useState(null);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  // ==========================================================

  const isEmail = (email) => {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (email.match(re)) return true;
    else return false;
  };

  const isEmpty = (string) => {
    if (string === "" || string?.trim() === "") return true;
    else return false;
  };

  const onChangeEmailSearch = (e) => {
    if (recordProps) {
      let searchKey = e.target.value;
      let tempAllArr = [...mainRecordProps];
      if (
        courseStatusSelected.trim() === "" ||
        courseStatusSelected === "all"
      ) {
        if (searchKey.trim() === "") {
          setSearchedRecords(tempAllArr);
          // console.log("You selected All");
        } else {
          // console.log("Course status selected ma inja inja");
          filtered = tempAllArr.filter(function (value, index, arr) {
            return (
              value.userEmail.toUpperCase().indexOf(searchKey.toUpperCase()) >
              -1
            );
          });
          setSearchedRecords(filtered);
        }
      } else {
        filtered = tempAllArr.filter(function (value, index, arr) {
          return (
            value.role === courseStatusSelected &&
            value.userEmail.toUpperCase().indexOf(searchKey.toUpperCase()) > -1
          );
        });
        setSearchedRecords(filtered);
      }
    }
  };

  const onClickUserDelete = (useremail, teamid, index) => {
    const confirmed = window.confirm(`Are you sure you want to delete ${useremail}?`);
    if (!confirmed) return;
    
    let tempArr = [...recordProps];
    tempArr.splice(index, 1);
    setRecordProps(tempArr);
    axios.post("/deleteUserFromTeam", { userEmail: useremail, teamId: teamid });
  };

  const onClickInviteUserButton = () => {
    if (
      !isEmpty(userInvite) &&
      isEmail(userInvite) &&
      !isEmpty(userInviteFullName)
    ) {
      const userFullName = userInviteFullName;
      const regex = /^[a-zA-Z\s]+$/;
      if (regex.test(userFullName)) {
        setInviteTeamButtonVisible(true);

        return axios
          .post("/returnTeamName", { teamId: inviteTeamId })
          .then((data) => {
            setTeamName(data.data);
          });
      } else {
        setInviteMessage("Please enter valid full name.");
      }
    } else if (isEmpty(userInvite) || isEmpty(userInviteFullName)) {
      setInviteMessage("Please fill out the username and email.");
    } else if (!isEmpty(userInvite) && !isEmail(userInvite)) {
      setInviteMessage("Please enter valid email.");
    }
    setResendInviteMessage("");
  };

  const onClickResendInviteEmailButton = (userEmail, userTeamId, userId, userFullName) => {
    axios
      .post("/returnTeamName", { teamId: userTeamId })
      .then((data) => {
        const teamName = data.data;

        const InviteeEmail = userEmail.toLowerCase();
        const InviteeFullName = userFullName.replace(/\b\w/g, (char) =>
          char.toUpperCase()
        );

        return axios.post("/inviteToTeam", {
          email: InviteeEmail,
          teamId: userTeamId,
          fullName: user.fullName,       // sender
          teamName: teamName,
          senderEmail: user.email,       // sender
          userName: InviteeFullName,     // invitee
          forceResend: true              // key addition
        });
      })
      .then(() => {
        setResendInviteMessage("Invite email resent."); 
      })
      .catch(() => {
        setResendInviteMessage("Failed to resend invite.");
      });

    setInviteMessage("");
  };

  const { resetTeamMember } = props;
  useEffect(() => {
    if (
      teamName &&
      !isEmpty(userInvite) &&
      isEmail(userInvite) &&
      !isEmpty(userInviteFullName)
    ) {
      const InviteeEmail = userInvite.toLowerCase();
      const InviteeFullName = userInviteFullName.replace(/\b\w/g, (char) =>
        char.toUpperCase()
      );

      axios
        .post("/inviteToTeam", {
          email: InviteeEmail,
          teamId: inviteTeamId,
          fullName: user.fullName,
          teamName: teamName,
          senderEmail: user.email,
          userName: InviteeFullName,
        })
        .then((data) => {
          console.log(data);
          setUserInvite("");
          setUserInviteFullName("");
          setInviteTeamButtonVisible(false);
          setInviteMessage(data.data.message);
          resetTeamMember(inviteTeamId);
        })
        .catch((err) => {
          setInviteMessage("Something wrong in inviting to team", err);
          setInviteTeamButtonVisible(false);
        });
    }

  }, [
    teamName,
    userInvite,
    userInviteFullName,
    inviteTeamId,
    user.fullName,
    user.email,
    resetTeamMember, 
  ]);

  useEffect(() => {
    if (props.data) {
      setRecordProps(props.data);
    }
  }, [props.data]);

  useEffect(() => {
    if (recordProps) {
      let tempArr = [...recordProps];
      tempArr.forEach((item, key) => {
        item.id = key;
      });
      setMainRecordProps(tempArr);
    }

    return () => {
      setMainRecordProps(null);
    };
  }, [recordProps]);

  useEffect(() => {
    if (mainRecordProps) {
      setSearchedRecords([...mainRecordProps]);
    }
  }, [mainRecordProps]);

  useEffect(() => {
    if (props.teamIdProp) {
      setInviteTeamId(props.teamIdProp);
    }
  }, [props.teamIdProp]);

  useEffect(() => {
    setInviteTeamId(props.teamIdProp);
  }, [props.teamIdProp]);

  useEffect(() => {
    return () => {
      setMainRecordProps(null);
      setRecordProps(null);
    };
  }, []);

  return (
    <Container>
      <InviteUserContainer>
        <TextField
          id="outlined-basic"
          label="Fullname"
          variant="outlined"
          onChange={(e) => setUserInviteFullName(e.target.value)}
          onFocus={() => setInviteMessage("")}
          value={userInviteFullName}
        />
        <TextField
          id="outlined-basic"
          label="Email"
          variant="outlined"
          onChange={(e) => setUserInvite(e.target.value)}
          onFocus={() => setInviteMessage("")}
          value={userInvite}
        />
        {!inviteTeamButtonVisible ? (
          <InviteUserButton
            onClick={() => onClickInviteUserButton()}
            disabled={inviteTeamButtonVisible}>
            Invite User
          </InviteUserButton>
        ) : (
          <InviteUserButton
            onClick={() => onClickInviteUserButton()}
            disabled={inviteTeamButtonVisible}>
            <CircularProgress color="inherit" />
          </InviteUserButton>
        )}
      </InviteUserContainer>
      <ErrorMessage>{inviteMessage}</ErrorMessage>
      <CustomTable>
        <SearchTable>
          <EmailSearchContainer>
            <EmailSearch
              onChange={(e) => onChangeEmailSearch(e)}
              placeholder="Email..."
            />
            <EmailSearchButton>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-search"
                viewBox="0 0 16 16">
                <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
              </svg>
            </EmailSearchButton>
          </EmailSearchContainer>
        </SearchTable>
        {/* =============The main pagination table is here============= */}
        <Paper sx={{ width: "100%", overflow: "hidden" }}>
          <TableContainer sx={{ height: "100%" }}>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <TableCell
                      key={column.id}
                      align={column.align}
                      style={{ minWidth: column.minWidth }}>
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>

              <TableBody>

                {searchedRecords ? (
                  searchedRecords
                    .sort((a,b) => a.userEmail.localeCompare(b.userEmail))
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row) => {
                      return (
                        <TableRow
                          hover
                          role="checkbox"
                          tabIndex={-1}
                          key={row.id}
                          style={{
                            display:
                              !row?.displayEmail &&
                              !row?.displayCourse &&
                              !row?.displayStatus
                                ? ""
                                : "none",
                          }}>
                          <TableCell>{row.userEmail}</TableCell>
                          <TableCell align="center">
                            <DeleteCompanyUserButton
                              onClick={() =>
                                onClickUserDelete(
                                  row.userEmail,
                                  row.teamId,
                                  row.id
                                )
                              }
                              disabled={
                                (props.role !== "admin" && props.role !== "owner") ||
                                row.userEmail === user.email
                              }>
                              <DeleteIcon
                                color={
                                  (props.role !== "admin" && props.role !== "owner") ||
                                  row.userEmail === user.email
                                    ? "disabled"
                                    : "inherit"
                                }
                              />
                            </DeleteCompanyUserButton>
                          </TableCell>
                          <TableCell align="center">
                            <ResendInviteEmail
                              onClick={() => 
                                onClickResendInviteEmailButton(
                                  row.userEmail,
                                  row.teamId,
                                  row.id,
                                  user.fullName
                                )}
                              disabled={
                                (props.role !== "admin" && props.role !== "owner") ||
                                row.userEmail === user.email
                              }>
                              {/* MUCH LOGIC STILL NEEDS TO BE APPLIED HERE (ROW. USEREMAIL) */}
                            <EmailIcon 
                              color={
                                (props.role !== "admin" && props.role !== "owner") ||
                                row.userEmail === user.email
                                  ? "disabled"
                                  : "inherit"
                              }
                            />
                            </ResendInviteEmail>
                          </TableCell>
                        </TableRow>
                      );
                    })
                ) : (
                  <TableRow></TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 10, 20]}
            component="div"
            count={ searchedRecords?.length || 0 }
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
        <ErrorMessage>{resendInviteMessage}</ErrorMessage>
      </CustomTable>
    </Container>
  );
}

export default AddDeleteUserCompany;

const Container = styled.div`
  padding: 20px;
`;
const CustomTable = styled.div`
  width: 100%;
`;
const SearchTable = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  /* grid-gap: 5px; */
  margin-bottom: 10px;
`;

const SearchContainers = [
  `
  position:relative;
display: flex;
justify-content: center;
align-items: center;

`,
];

const EmailSearchContainer = styled.div(SearchContainers);

const SearchBoxes = [
  `
width: 100%;
padding: 7px 7px 7px 35px;

option{
    // padding:7px 0px 7px 0px;
    // height:20px;
}
`,
];

const SearchButtons = [
  `
position:absolute;
border:none;
outline:none;
left:15px;
background-color: transparent;
// cursor:pointer;
svg{
    fill:rgba(0,0,0,0.5)
}
`,
];

const EmailSearch = styled.input(SearchBoxes);
const EmailSearchButton = styled.button(SearchButtons);

const DeleteCompanyUserButton = styled.button`
  background-color: transparent;
  border: none;
  outline: none;
  cursor: pointer;
  &:disabled {
    cursor: default;
  }
`;
const ResendInviteEmail = styled.button`
  background-color: transparent;
  border: none;
  outline: none;
  cursor: pointer;
  &:disabled {
    cursor: default;
  }
`;
const InviteUserContainer = styled.div`
  /* margin-bottom: 20px; */
  display: grid;
  grid-template-columns: auto auto 150px;
  grid-gap: 5px;
`;

const InviteUserButton = styled.button`
  cursor: pointer;
  padding: 5px;
  background-color: rgba(95, 176, 95, 0.9);
  transition: all 0.2s ease-in-out;
  color: white;
  border-radius: 4px;
  border: none;
  // height: 40px;

  &:hover {
    background-color: rgba(95, 176, 95, 1);
  }

  &:disabled {
    background-color: rgba(1, 1, 1, 0.1);
    cursor: default;
  }

  span {
    height: 20px !important;
    width: 20px !important;
  }
`;

const ErrorMessage = styled.div`
  
  margin: 5px 0px 15px 0px;
  color: red;
  font-size: 16px;
  height: 10px;
`;
